import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

const zhCNMessages = {
  "edu.pages.publicCourses.title": "公开课程",
  "edu.pages.publicCourses.subtitle": "这里治理的是公开课发布实例，不是源课程本体；同步决策、快照目录和轻运营字段统一收口在同一工作面。",
  "edu.pages.publicCourses.notice": "公开课发布实例应严格复用共享管理端治理壳层，不单独发明一套课程广场后台工作流。",
  "edu.pages.publicCourses.actions.createThread": "发起留言主题",
  "edu.pages.publicCourses.actions.createNotice": "发送通知",
  "edu.pages.publicCourses.actions.publish": "发布",
  "edu.pages.publicCourses.actions.sync": "同步快照",
  "edu.pages.publicCourses.actions.pause": "暂停",
  "edu.pages.publicCourses.messages.loadFailed": "公开课程治理加载失败",
  "edu.pages.publicCourses.messages.detailLoadFailed": "公开课程详情加载失败",
  "edu.pages.publicCourses.messages.publishFailed": "公开课发布失败",
  "edu.pages.publicCourses.messages.syncFailed": "公开课同步失败",
  "edu.pages.publicCourses.messages.pauseFailed": "公开课暂停失败",
  "edu.pages.publicCourses.messages.noticeCreateFailed": "公开课通知发送失败",
  "edu.pages.publicCourses.messages.threadCreateFailed": "公开课留言主题发布失败",
  "edu.pages.publicCourses.labels.course": "公开课发布实例",
  "edu.pages.publicCourses.labels.sourceType": "来源",
  "edu.pages.publicCourses.labels.status": "状态",
  "edu.pages.publicCourses.labels.sourceCourse": "源课程",
  "edu.pages.publicCourses.labels.version": "公开版本",
  "edu.pages.publicCourses.labels.syncState": "同步状态",
  "edu.pages.publicCourses.labels.sourceCourseVersion": "源课程版本",
  "edu.pages.publicCourses.labels.operationBoundary": "轻运营边界",
  "edu.pages.publicCourses.labels.publicCourseOpsFields": "公开课轻运营字段",
  "edu.pages.publicCourses.labels.syncRule": "同步规则",
  "edu.pages.publicCourses.labels.sourceCatalogSummary": "源课程目录摘要",
  "edu.pages.publicCourses.labels.snapshotCatalogSummary": "当前快照目录摘要",
  "edu.pages.publicCourses.labels.contentBoundary": "课程本体边界",
  "edu.pages.publicCourses.labels.currentDetail": "当前公开课详情",
  "edu.pages.publicCourses.labels.focusItems": "当前关注",
  "edu.pages.publicCourses.labels.syncDecision": "同步决策提示",
  "edu.pages.publicCourses.labels.catalogDelta": "源课程变更摘要",
  "edu.pages.publicCourses.labels.sectionProjection": "当前课程目录投影",
  "edu.pages.publicCourses.labels.boardThreads": "公开课留言主题",
  "edu.pages.publicCourses.labels.notices": "公开课通知留痕",
  "edu.pages.publicCourses.labels.nextActions": "下一步入口",
  "edu.pages.publicCourses.labels.learnerEntry": "学员进入方式",
  "edu.pages.publicCourses.labels.interactionSpace": "互动空间",
  "edu.pages.publicCourses.labels.sourceDelta": "源课程变更",
  "edu.pages.publicCourses.labels.operator": "当前治理人",
  "edu.pages.publicCourses.labels.lastSyncedAt": "最近同步时间",
  "edu.pages.publicCourses.placeholders.emptyDetail": "请选择一门公开课程查看详情。",
  "edu.pages.publicCourses.placeholders.emptyTextList": "暂无内容。",
  "edu.pages.publicCourses.placeholders.emptySections": "当前公开课快照目录为空。",
  "edu.pages.publicCourses.placeholders.emptyThreads": "当前还没有公开课留言主题。",
  "edu.pages.publicCourses.placeholders.emptyNotices": "当前还没有公开课通知留痕。",
  "edu.pages.publicCourses.placeholders.emptySourceCourses": "当前没有可供带回的课程。",
  "edu.pages.publicCourses.messages.catalogDeltaDescription": "上方首屏摘要先给出当前差异总览；这里继续展开具体变更条目，方便决定是否同步快照。",
  "edu.pages.publicCourses.messages.boardThreadDescription": "当前公开课留言板按主题摘要留痕：管理员或老师可发起主题，学员端留言板会读取同一批真实主题摘要。",
  "edu.pages.publicCourses.messages.noticeDescription": "这里统一展示管理员手工发送的公开课通知；学员在公开课学习入口的通知 TAB 会读取同一批真实通知留痕，消息中心继续承接跨课程的待办与已读历史留痕。",
  "edu.pages.publicCourses.messages.threadTrace": "主题会进入公开课真实留痕",
  "edu.pages.publicCourses.messages.threadTraceDescription": "学员在公开课学习入口的留言板 TAB 会读取这些主题摘要；这里当前只维护主题摘要留痕。",
  "edu.pages.publicCourses.messages.noticeTrace": "通知会进入公开课真实留痕",
  "edu.pages.publicCourses.messages.noticeTraceDescription": "学员在公开课学习入口的通知 TAB 会读取这些通知摘要；消息中心继续承接跨课程的待办与已读历史留痕。",
  "edu.pages.publicCourses.modals.threadTitle": "发起公开课留言主题",
  "edu.pages.publicCourses.modals.sourceCoursePickerTitle": "选择来源课程",
  "edu.pages.publicCourses.modals.noticeTitle": "发送公开课通知",
  "edu.pages.publicCourses.modals.publishThread": "发布主题",
  "edu.pages.publicCourses.modals.sendNotice": "发送通知",
  "edu.pages.publicCourses.modals.threadTag": "留言主题",
  "edu.pages.publicCourses.forms.sourceCourseRequired": "请选择一门源课程",
  "edu.pages.publicCourses.forms.sourceCoursePlaceholder": "从课程中心查找带回一门真实课程",
  "edu.pages.publicCourses.forms.titlePlaceholder": "例如：网络安全基础公开课",
  "edu.pages.publicCourses.forms.descriptionPlaceholder": "补充面向课程广场的轻运营描述",
  "edu.pages.publicCourses.forms.defaultDescriptionPrefix": "当前公开课尚未补充运营描述；",
  "edu.pages.publicCourses.forms.threadTitlePlaceholder": "例如：公开课案例讨论入口",
  "edu.pages.publicCourses.forms.noticeTitlePlaceholder": "例如：本周公开课学习提醒",
  "edu.pages.publicCourses.forms.summaryPlaceholder": "给学员看到的简短摘要，可留空。",
  "edu.pages.publicCourses.forms.threadContentPlaceholder": "写下本次公开课主题的详细内容。",
  "edu.pages.publicCourses.forms.noticeContentPlaceholder": "写下本次公开课通知的详细内容。",
  "edu.pages.publicCourses.forms.threadTitleLabel": "主题标题",
  "edu.pages.publicCourses.forms.threadSummaryLabel": "主题摘要",
  "edu.pages.publicCourses.forms.threadContentLabel": "主题正文",
  "edu.pages.publicCourses.forms.sourceCourseLabel": "来源课程",
  "edu.pages.publicCourses.forms.titleLabel": "公开课标题",
  "edu.pages.publicCourses.forms.descriptionLabel": "公开课描述",
  "edu.pages.publicCourses.forms.sourceTypeLabel": "来源类型",
  "edu.pages.publicCourses.forms.noticeTitleLabel": "通知标题",
  "edu.pages.publicCourses.forms.noticeSummaryLabel": "通知摘要",
  "edu.pages.publicCourses.forms.noticeContentLabel": "通知正文",
  "edu.pages.publicCourses.forms.threadTitleRequired": "请输入主题标题",
  "edu.pages.publicCourses.forms.threadTitleMax": "主题标题不能超过 128 个字符",
  "edu.pages.publicCourses.forms.threadSummaryMax": "主题摘要不能超过 256 个字符",
  "edu.pages.publicCourses.forms.threadContentRequired": "请输入主题正文",
  "edu.pages.publicCourses.forms.threadContentMax": "主题正文不能超过 4000 个字符",
  "edu.pages.publicCourses.forms.titleRequired": "请输入公开课标题",
  "edu.pages.publicCourses.forms.sourceTypeRequired": "请选择来源类型",
  "edu.pages.publicCourses.forms.noticeTitleRequired": "请输入通知标题",
  "edu.pages.publicCourses.forms.noticeTitleMax": "通知标题不能超过 128 个字符",
  "edu.pages.publicCourses.forms.noticeSummaryMax": "通知摘要不能超过 256 个字符",
  "edu.pages.publicCourses.forms.noticeContentRequired": "请输入通知正文",
  "edu.pages.publicCourses.forms.noticeContentMax": "通知正文不能超过 4000 个字符",
  "edu.pages.publicCourses.pickers.pick": "查找带回",
  "edu.pages.publicCourses.pickers.clear": "清空",
  "edu.pages.publicCourses.pickers.submitCourse": "带回已选课程",
  "edu.pages.publicCourses.pickers.courseTitle": "课程",
  "edu.pages.publicCourses.pickers.statusTitle": "状态",
  "edu.pages.publicCourses.values.sourceSystem": "系统内置",
  "edu.pages.publicCourses.values.sourceShared": "共享课程",
  "edu.pages.publicCourses.values.statusPublished": "已发布",
  "edu.pages.publicCourses.values.statusStaged": "待上架",
  "edu.pages.publicCourses.values.statusPaused": "已暂停",
  "edu.pages.publicCourses.confirm.publishTitle": "确认发布当前公开课？",
  "edu.pages.publicCourses.confirm.publishDescription": "发布后会进入正式公开课可见范围，请确认当前轻运营字段和快照目录已准备完成。",
  "edu.pages.publicCourses.confirm.syncTitle": "确认同步当前公开课快照？",
  "edu.pages.publicCourses.confirm.syncDescription": "同步会把源课程的最新快照投影到当前公开课实例，请先确认同步决策提示中的差异。",
  "edu.pages.publicCourses.confirm.pauseTitle": "确认暂停当前公开课？",
  "edu.pages.publicCourses.confirm.pauseDescription": "暂停后，学员入口会按暂停状态收口，但历史留痕会继续保留。",
} satisfies MessageTree;

export const eduPublicCoursesPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": zhCNMessages,
  en: zhCNMessages,
  ja: zhCNMessages,
};
